import * as types from '../../action-types';

export default sessionData => ({
  type: types.SET_ADYEN_V2_SESSION_DATA,
  sessionData,
});
